/* eslint-disable max-classes-per-file */
export class DestinationItem {
  countryId: number;

  countryName: string;

  countrySlug: string;

  cityId: number;

  citySlug: string;

  cityName: string;

  price: number;

  currency: string;

  photoPath: string;

  name: string;

  slug: string;

  constructor(data: any) {
    this.countryId = data.countryId || 0;
    this.countryName = data.countryName || "";
    this.countrySlug = data.countrySlug || "";
    this.cityId = data.cityId || 0;
    this.citySlug = data.citySlug || "";
    this.cityName = data.cityName || "";
    this.price = data.price || 0;
    this.currency = data.currency || "";
    this.photoPath = data.photoPath || "";
    this.name = data.name || "";
    this.slug = data.slug || "";
  }
}

export class ToursRecommendationsItems {
  id: number;

  name: string;

  slug: string;

  countryId: number;

  countrySlug: string;

  countryName: string;

  cityId: number;

  citySlug: string;

  cityName: string;

  photoPath: string;

  isCampaign: boolean;

  constructor(data: Partial<ToursRecommendationsItems>) {
    this.id = data?.id || 0;
    this.name = data?.name || "";
    this.slug = data?.slug || "";
    this.countryId = data?.countryId || 0;
    this.countrySlug = data?.countrySlug || "";
    this.countryName = data?.countryName || "";
    this.cityId = data?.cityId || 0;
    this.citySlug = data?.citySlug || "";
    this.cityName = data?.cityName || "";
    this.photoPath = data?.photoPath || "";
    this.isCampaign = data?.isCampaign || false;
  }
}

export class ResponseTourDestinationRecommend {
  status: boolean;

  message: string;

  cache: number;

  data: {
    destinations: DestinationItem[];
  };

  constructor(res: any) {
    this.status = res?.status || false;
    this.message = res?.message || "";
    this.cache = res?.cache || 0;
    this.data = {
      destinations: (res?.data?.destinations || []).map(
        (des: any) => new DestinationItem(des),
      ),
    };
  }
}

export class ResponseTourSuggestion {
  status: boolean;

  message: string | null;

  cache: number;

  data: {
    recommendations: ToursRecommendationsItems[];
    destinations: DestinationItem[];
  };

  constructor(data: any) {
    this.status = data?.status || false;
    this.message = data?.message || "";
    this.cache = data?.cache || 1;
    this.data = {
      recommendations: (data?.data?.recommendations || []).map(
        (recommend: any) => new ToursRecommendationsItems(recommend),
      ),
      destinations: (data?.data?.destinations || []).map(
        (des: any) => new DestinationItem(des),
      ),
    };
  }
}
